import { FunctionComponent } from 'react';
import _ from 'lodash';
import { UserPermissionsCard, UserPermissionsCardTranslations } from '@cdaas/reusable-components-daas';
import { useTranslation } from 'react-i18next';
import { UserGroupResponse, UserRole } from '@cdaas/api-clients/dist/asset-admin-openapi';

// TODO change this to use asset-service-openapi's UserRole. Atm reusable UserPermissions uses own not enum based user roles types
export type ReusableUserRoles = `${UserRole}`[];

interface UserPermissionsProps {
  userGroup: UserGroupResponse;
  updateUserGroupUserPermissions: (values: Pick<UserGroupResponse, 'default_user_roles'>) => Promise<boolean>;
}

export const UserPermissions: FunctionComponent<UserPermissionsProps> = ({ userGroup, updateUserGroupUserPermissions }) => {
  const { t: tUserGroups } = useTranslation('userGroups');
  const { t: tGlobal } = useTranslation('global');

  const userPermissionTranslations: UserPermissionsCardTranslations = {
    title: tUserGroups('userPermissions.title'),
    bodyText: tUserGroups('userPermissions.helpText'),
    adminRoleName: _.capitalize(tGlobal('userRoles.admin')),
    userRoleName: _.capitalize(tGlobal('userRoles.user')),
    userLiteRoleName: _.capitalize(tGlobal('userRoles.user-lite')),
    approverRoleName: _.capitalize(tGlobal('userRoles.approver')),
    ordererRoleName: _.capitalize(tGlobal('userRoles.orderer')),
    saveButton: tUserGroups('userPermissions.saveButton'),
    cancelButton: tUserGroups('userPermissions.cancelButton'),
    errorTitle: tUserGroups('userPermissions.saveErrorTitle'),
    errorMessage: tUserGroups('userPermissions.saveErrorMessage'),
  };

  const saveUserPermissions = (values: ReusableUserRoles) => {
    return updateUserGroupUserPermissions({ default_user_roles: values as UserRole[] });
  };

  return (
    <UserPermissionsCard
      userRoles={userGroup?.default_user_roles || []}
      translations={userPermissionTranslations}
      submitValues={saveUserPermissions}
    />
  );
};
